<template>
    <section class="py-20 flex justify-center items-center">
        <div class="container mx-auto px-4 text-center mt-40">
            <div class="text-center mb-16">
                <h2 class="section-title text-slate-700 dark:text-slate-300">Contact Me</h2>
                <p class="section-subtitle text-slate-700 dark:text-slate-300">Let's discuss your project</p>
            </div>
            <div class="mx-auto w-full">
                <a href="https://wa.me/6281808425604?text=Hello%20Bahriyanto%20Anang%2C%20I%20want%20to%20discuss%20about%20my%20project"
                    target="_blank" class="btn-primary w-full">
                    <i class="fas fa-paper-plane mr-2"></i>
                    Contact Me
                </a>
            </div>
        </div>
    </section>
</template>